import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { jobsAdminApi } from "../../api/jobsAdminApi";
var KEYS = {
    all: ["admin", "jobs"],
    one: function (id) { return ["admin", "jobs", id]; },
};
export var useJobs = function () {
    return useQuery({
        queryKey: KEYS.all,
        queryFn: jobsAdminApi.list,
        refetchInterval: 1500,
        staleTime: 0,
    });
};
export var useJob = function (id) {
    return useQuery({
        queryKey: KEYS.one(id !== null && id !== void 0 ? id : ""),
        queryFn: function () { return (id ? jobsAdminApi.get(id) : undefined); },
        enabled: !!id,
        refetchInterval: function (q) {
            var data = q.state.data;
            if (!data)
                return 1000;
            if (data.status === "done" || data.status === "failed")
                return false;
            return 1000;
        },
        staleTime: 0,
    });
};
export var useEnqueueJob = function () {
    var qc = useQueryClient();
    return useMutation({
        mutationFn: function (args) { return jobsAdminApi.enqueue(args); },
        onSuccess: function () { return qc.invalidateQueries({ queryKey: KEYS.all }); },
    });
};
